import { useEffect } from 'react';
import { useAccounts } from '~/src/hooks/useAccounts';
import { getAppsOrigin, getEnvDomain } from '~/src/utils';

export const useAccountSelectorLogic = () => {
  const { accounts, loading, error, getAccounts } = useAccounts();

  useEffect(() => {
    getAccounts();
  }, []);

  const envDomain = getEnvDomain();
  const appsOrigin = getAppsOrigin();
  if (!loading && accounts.length === 0) {
    // If no accounts move to welcome page
    document.location = `/welcome`;
  } else if (!loading && accounts.length === 1) {
    // If one account redirect to that account
    const { accountId, accountSubdomain } = accounts[0];
    const query = new URLSearchParams(window.location.search);
    const path = query.get('destination') || '/home';

    //Set that account cookie
    document.cookie = `j1-account-session=${JSON.stringify({
      accountId,
      subdomain: accountSubdomain,
    })}; domain=${envDomain}`;
    document.location = `${appsOrigin}${path}`;
  }

  return {
    accounts,
    loading,
    error,
  };
};
